export default function focus($rootScope, $timeout) {
  'ngInject';

  return function link(name) {
    $timeout(() => {
      $rootScope.$broadcast('focusOn', name);
    });
  };
}
